"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});


var appName = process.env.REACT_APP_NAME;

//GET methods
var getAccessToken = exports.getAccessToken = function getAccessToken() {
  return localStorageGet("token");
};
var getdeviceinfo = exports.getdeviceinfo = function getdeviceinfo() {
  return localStorageGet("deviceinfo");
};
var getUserInfo = exports.getUserInfo = function getUserInfo() {
  return localStorageGet("user-info");
};
var getTenantId = exports.getTenantId = function getTenantId() {
  return localStorageGet("tenant-id");
};
// export const getdeviceinfo = () => {
//   return localStorageGet("deviceinfo");
// };
var getLocalization = exports.getLocalization = function getLocalization(key) {
  return localStorage.getItem(key);
};
var getLocale = exports.getLocale = function getLocale() {
  return localStorage.getItem("locale");
};

var getDefaultLocale = exports.getDefaultLocale = function getDefaultLocale() {
  return localStorage.getItem("defaultLocale");
};
var getPGRSector = exports.getPGRSector = function getPGRSector() {
  return localStorage.getItem("PGRSector");
};

var getapplicationType = exports.getapplicationType = function getapplicationType() {
  return localStorage.getItem("applicationType");
};

var getapplicationNumber = exports.getapplicationNumber = function getapplicationNumber() {
  return localStorage.getItem("ApplicationNumber");
};

var getapplicationMode = exports.getapplicationMode = function getapplicationMode() {
  return localStorage.getItem("applicationMode");
};

var getOPMSTenantId = exports.getOPMSTenantId = function getOPMSTenantId() {
  return localStorage.getItem('opms-tenant-id');
};
var getNULMTenantId = exports.getNULMTenantId = function getNULMTenantId() {
  return localStorage.getItem('opms-tenant-id');
};

var getServiceRequestStatus = exports.getServiceRequestStatus = function getServiceRequestStatus() {
  return localStorage.getItem("ServiceRequestStatus");
};

var getSLADays = exports.getSLADays = function getSLADays() {
  return localStorage.getItem("SLADays");
};
var getCurrentAssignee = exports.getCurrentAssignee = function getCurrentAssignee() {
  return localStorage.getItem("CurrentAssignee");
};

var getEncroachmentType = exports.getEncroachmentType = function getEncroachmentType() {
  return localStorage.getItem('encroachmentType');
};
var getModule = exports.getModule = function getModule() {
  return localStorage.getItem("module");
};
var getHCRoles = exports.getHCRoles = function getHCRoles() {
  return localStorage.getItem("HCRoles");
};

var getEChallanPaymentMailSent = exports.getEChallanPaymentMailSent = function getEChallanPaymentMailSent() {
  return localStorage.getItem('EChallanPaymentMailSent');
};

var getIsUT = exports.getIsUT = function getIsUT() {
  return localStorage.getItem('isUT');
};

//SET methods 
var setHCRoles = exports.setHCRoles = function setHCRoles(HCRoles) {
  localStorageSet("HCRoles", HCRoles, null);
};

var setISUT = exports.setISUT = function setISUT(isut) {
  localStorageSet("isUT", isut, null);
};

var setCurrentAssignee = exports.setCurrentAssignee = function setCurrentAssignee(CurrentAssignee) {
  localStorageSet("CurrentAssignee", CurrentAssignee, null);
};
var setSLADays = exports.setSLADays = function setSLADays(SLADays) {
  localStorageSet("SLADays", SLADays, null);
};
var setServiceRequestStatus = exports.setServiceRequestStatus = function setServiceRequestStatus(ServiceRequestStatus) {
  localStorageSet("ServiceRequestStatus", ServiceRequestStatus, null);
};
var setUserInfo = exports.setUserInfo = function setUserInfo(userInfo) {
  localStorageSet("user-info", userInfo, null);
};
var setAccessToken = exports.setAccessToken = function setAccessToken(token) {
  localStorageSet("token", token, null);
};
var setRefreshToken = exports.setRefreshToken = function setRefreshToken(refreshToken) {
  localStorageSet("refresh-token", refreshToken, null);
};
var setTenantId = exports.setTenantId = function setTenantId(tenantId) {
  localStorageSet("tenant-id", tenantId, null);
};
var setLocale = exports.setLocale = function setLocale(locale) {
  localStorageSet("locale", locale);
};
var setReturnUrl = exports.setReturnUrl = function setReturnUrl(url) {
  localStorageSet("returnUrl", url);
};

var setDefaultLocale = exports.setDefaultLocale = function setDefaultLocale(locale) {
  localStorageSet("defaultLocale", locale);
};
var setPGRSector = exports.setPGRSector = function setPGRSector(locale) {
  localStorageSet("PGRSector", locale);
};

var setapplicationType = exports.setapplicationType = function setapplicationType(applicationTypeName) {
  localStorageSet("applicationType", applicationTypeName);
};

var setapplicationNumber = exports.setapplicationNumber = function setapplicationNumber(applicationNumber) {
  localStorageSet("ApplicationNumber", applicationNumber);
};
//setCloseComplaintsCount
var setCloseComplaintsCount = exports.setCloseComplaintsCount = function setCloseComplaintsCount(Count) {
  localStorageSet("CloseComplaintsCount", Count);
};
var getCloseComplaintsCount = exports.getCloseComplaintsCount = function getCloseComplaintsCount() {
  return localStorage.getItem('CloseComplaintsCount');
};
var setapplicationMode = exports.setapplicationMode = function setapplicationMode(applicationMode) {
  localStorageSet("applicationMode", applicationMode);
};
var setOPMSTenantId = exports.setOPMSTenantId = function setOPMSTenantId(OPMSTenantId) {
  localStorageSet('opms-tenant-id', OPMSTenantId);
};
var setNULMTenantId = exports.setNULMTenantId = function setNULMTenantId(NULMTenantId) {
  localStorageSet('nulm-tenant-id', NULMTenantId);
};
var setModule = exports.setModule = function setModule(moduleName) {
  localStorageSet("module", moduleName);
};

var seteventid = exports.seteventid = function seteventid(eventId) {
  localStorageSet("eventId", eventId);
};
var seteventuuid = exports.seteventuuid = function seteventuuid(eventuuId) {
  localStorageSet("eventuuId", eventuuId);
};

var setEncroachmentType = exports.setEncroachmentType = function setEncroachmentType(encroachmentType) {
  localStorageSet('encroachmentType', encroachmentType);
};

var setEChallanPaymentMailSent = exports.setEChallanPaymentMailSent = function setEChallanPaymentMailSent(isChallanPayMailSent) {
  localStorageSet('EChallanPaymentMailSent', isChallanPayMailSent);
};

//Remove Items (LOGOUT)
var clearUserDetails = exports.clearUserDetails = function clearUserDetails() {
  Object.keys(localStorage).forEach(function (key) {
    if (key.startsWith(appName)) {
      window.localStorage.removeItem(key);
    }
  });

  if (window.localStorage.getItem("module")) window.localStorage.removeItem("module");

  if (window.localStorage.getItem("ecno")) window.localStorage.removeItem("ecno");
};
//Role specific get-set Methods
var localStorageGetMoh = exports.localStorageGetMoh = function localStorageGetMoh(key, path) {
  var appName = process.env.REACT_APP_NAME;
  var value = null;
  if (path) {
    var data = JSON.parse(window.localStorage.getItem(appName + "." + key)) || null;
    value = get(data, path);
  } else {
    value = window.localStorage.getItem(key) || null;
  }
  return value;
};
var localStorageGet = exports.localStorageGet = function localStorageGet(key, path) {
  var appName = process.env.REACT_APP_NAME;
  var value = null;
  if (path) {
    var data = JSON.parse(window.localStorage.getItem(appName + "." + key)) || null;
    value = get(data, path);
  } else {
    value = window.localStorage.getItem(appName + "." + key) || null;
  }
  return value;
};
var localStorageSet = exports.localStorageSet = function localStorageSet(key, data, path) {
  var appName = process.env.REACT_APP_NAME;
  var storedData = window.localStorage.getItem(appName + "." + key);

  if (path) {
    set(storedData, path, data);
    window.localStorage.setItem(appName + "." + key, storedData);
    window.localStorage.setItem(key, storedData);
  } else {
    window.localStorage.setItem(appName + "." + key, data);
    window.localStorage.setItem(key, data);
  }
};
//Remove Item
var lSRemoveItem = exports.lSRemoveItem = function lSRemoveItem(key) {
  var appName = process.env.REACT_APP_NAME;
  window.localStorage.removeItem(appName + "." + key);
};

var lSRemoveItemlocal = exports.lSRemoveItemlocal = function lSRemoveItemlocal(key) {
  window.localStorage.removeItem(key);
};

// get tenantId for Employee/Citizen
var getTenantIdCommon = exports.getTenantIdCommon = function getTenantIdCommon() {
  return process.env.REACT_APP_NAME === "Citizen" ? JSON.parse(getUserInfo()).permanentCity : getTenantId();
};


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/utils/localStorageUtils/index.js
// module id = 23
// module chunks = 895